import { p as proxyCustomElement, H, h, c as Host } from './p-DWmaQhSz.js';
import { r as removeSSRSlot } from './p-Cfy_DCci.js';
import { d as defineCustomElement$4 } from './p-BrGjr5zY.js';
import { d as defineCustomElement$3 } from './p-CDOqC5he.js';
import { d as defineCustomElement$2 } from './p-CDGub1VX.js';

/*!
 * Planning Center Tapestry Web Components
 * Version: 1.3.0
 */

let sidenavMenuId = 0;
const Sidenav = /*@__PURE__*/ proxyCustomElement(class Sidenav extends H {
    constructor() {
        super();
        this.__registerHost();
        this.sidenavMenuId = `tds-sidenav-menu-${sidenavMenuId++}`;
        /**
         * The label for the sidenav, used for accessibility.
         */
        this.label = "Secondary";
    }
    // --------------------------------------------------------------------------
    //
    //  Lifecycle
    //
    // --------------------------------------------------------------------------
    componentDidLoad() {
        removeSSRSlot(this.el);
    }
    // --------------------------------------------------------------------------
    //
    //  Render Methods
    //
    // --------------------------------------------------------------------------
    render() {
        return (h(Host, { key: '212777ba38ed4cfbf5705a36ccd494e3ef7e5993', class: "tds-sidenav" }, h("nav", { key: 'f265aa7e210217629fbb72cd7f8c79bfd8277420', id: this.sidenavMenuId, class: "tds-sidenav-nav", "aria-label": this.label }, h("tds-sidenav-responsive-header", { key: '8e5a0a8cfc4046a12685f8cd72ba43e11e186fc9', label: this.selectedItemLabel }), h("tds-sidenav-popover", { key: '08adfba563693cee1eb2bb3182a7e3c225ba37a0' }, h("slot", { key: 'c8bdb4032102c338024627d940e90c283ae29522' })))));
    }
    get el() { return this; }
}, [6, "tds-sidenav", {
        "label": [1],
        "selectedItemLabel": [1, "selected-item-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["tds-sidenav", "tds-popover-container", "tds-sidenav-popover", "tds-sidenav-responsive-header"];
    components.forEach(tagName => { switch (tagName) {
        case "tds-sidenav":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, Sidenav);
            }
            break;
        case "tds-popover-container":
            if (!customElements.get(tagName)) {
                defineCustomElement$4();
            }
            break;
        case "tds-sidenav-popover":
            if (!customElements.get(tagName)) {
                defineCustomElement$3();
            }
            break;
        case "tds-sidenav-responsive-header":
            if (!customElements.get(tagName)) {
                defineCustomElement$2();
            }
            break;
    } });
}
const defineCustomElement = defineCustomElement$1;

export { defineCustomElement };
//# sourceMappingURL=tds-sidenav.js.map
